
// 长按指令
const longpress = {
  bind(el, binding) {
    let timer = null
    const longPressTime = 500

    const start = (e) => {
      if (e.type === 'click') return

      timer = setTimeout(() => {
        binding.value(e)
      }, longPressTime)
    }

    const cancel = () => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
    }

    el.addEventListener('touchstart', start)
    el.addEventListener('touchend', cancel)
    el.addEventListener('touchcancel', cancel)

    // 保存引用以便清理
    el._longPressHandlers = { start, cancel }
  },

  unbind(el) {
    if (el._longPressHandlers) {
      el.removeEventListener('touchstart', el._longPressHandlers.start)
      el.removeEventListener('touchend', el._longPressHandlers.cancel)
      el.removeEventListener('touchcancel', el._longPressHandlers.cancel)
    }
  }
}

// 导出插件对象
export default {
  install(Vue) {
    Vue.directive('longpress', longpress)
  }
}